import { type } from '@ngrx/signals';
import { event, eventGroup } from '@ngrx/signals/events';
import { ReviewExportData, ReviewsRequest } from '@models/online-reputation.models';

export type ReviewExportError = 'tooMany' | 'failed';

export const startReviewExport = event(
  '[Review export] Start',
  type<ReviewsRequest>(),
);

export const reviewExportApiEvents = eventGroup({
  source: 'Review export API',
  events: {
    downloaded: type<ReviewExportData>(),
    failed: type<ReviewExportError>(),
  },
});
